export default __webpack_public_path__ + "static/media/EM0333.34I-41677_-24951_0.fe0434f6.jpg";